import type { StorageService } from "@/persistence/StorageService";
import { Game } from "./Game";
import { loadPlayableStory } from "@/story/loader";
import { incrementPlays } from "@/lib/api";

export interface MountedGame {
  game: Game;
  dispose: () => void;
}

export async function mountGameInto(
  root: HTMLElement,
  storyId: string,
  storage: StorageService,
  onExit: () => void
): Promise<MountedGame> {
  const container = document.createElement("div");
  container.className = "game-root";
  root.appendChild(container);

  const story = await loadPlayableStory(storyId);
  const game = new Game(container, story, { storage, onExit });
  await game.start();

  if (!storyId.startsWith("builtin")) {
    void incrementPlays(storyId).catch(() => undefined);
  }

  return {
    game,
    dispose: () => {
      game.dispose();
      container.remove();
    },
  };
}
